import { Avatar } from "antd";
import c2pLogo from "@assets/icons/logo.svg";
import ProfileDropdown from "./ProfileDropdown";
import { CaretDownOutlined } from "@ant-design/icons";
import { useState } from "react";
import { getLoggedInUser } from "@utils/helpers";
import { NAVLINKS } from "./navlinks";
import { NavLink, useLocation } from "react-router-dom";
import { IconButton } from "@common/Buttons";
import verticalDotsIcon from "@assets/icons/vertical_dots.svg";
import MobileDrawer from "./MobileDrawer";
import { ADMIN, USER } from "@utils/roleRights";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { user } = getLoggedInUser();
  const { pathname } = useLocation();

  const activeClasses = (isActive, link) => {
    const active = isActive || link.activeOnOtherPaths.includes(pathname);
    const role = user && user?.isAdmin ? ADMIN : USER;
    const email = user?.email;
    return link.allowedRoles.includes(role) && (!link.allowedEmails.length || link.allowedEmails.includes(email))
      ? `${
          active
            ? " !font-bold !text-primary-tint !bg-secondary-main"
            : "!font-normal !bg-transparent !text-secondary-main"
        } text-[10px] !font-sans !tracking-wider lg:text-xs rounded-4 xl:text-sm flex py-2.5 px-1.5 xl:!p-2.5 transition-all duration-300`
      : "hidden";
  };

  return (
    <div className="flex items-center gap-5 justify-between w-full h-[70px] px-2 lg:px-6 shadow-bottom bg-gradient-to-b from-primary-main to-primary-tint">
      {/* mobile navigation */}

      {/* logo */}
      {/* mobile */}
      <div className="flex items-center gap-2 md:hidden">
        <img
          src={verticalDotsIcon}
          alt="vertical dots"
          onClick={() => setIsDrawerOpen(true)}
        />
        <img src={c2pLogo} alt="header" className="h-8 lg:h-auto" />
      </div>

      {/* desktop */}
      <div className="hidden md:block">
        <img src={c2pLogo} alt="header" className="h-8 lg:h-auto" />
      </div>

      {/* //navigation links  desktop*/}
      <div className="items-center hidden gap-2 xl:gap-4 md:flex">
        {NAVLINKS.map((link) => {
          return (
            <NavLink
              to={link.path}
              key={link.label}
              className={({ isActive }) => activeClasses(isActive, link)}
            >
              {({ isActive }) => {
                const active =
                  isActive || link.activeOnOtherPaths.includes(pathname);
                return active ? (
                  <IconButton
                    icon={link.activeIcon}
                    label={link.label}
                    className={
                      "flex items-center text-start xl:text-center gap-3 xl:gap-1.5 transition-all"
                    }
                  />
                ) : (
                  <IconButton
                    icon={link.icon}
                    label={link.label}
                    className={
                      "flex items-center text-start xl:text-center gap-3 xl:gap-1.5 transition-all"
                    }
                  />
                );
              }}
            </NavLink>
          );
        })}
      </div>

      {/* navigation dropdown for mobile */}
      <MobileDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />

      {/* user menu */}
      <div>
        <ProfileDropdown isOpen={isOpen} setIsOpen={setIsOpen}>
          <div
            className={`bg-gradient-to-b from-primary-main to-primary-tint border rounded-4 border-primary-tint px-2 flex items-center py-1 lg:p-[7px_15px]`}
          >
            <Avatar
              size={28}
              className="cursor-pointer !place-items-center bg-[#f6f0a7] text-[#514513] border-2 border-white !text-sm font-semibold hover:scale-110 transition-all duration-500 ease-linear shadow-all-sides"
            >
              {user?.firstName[0].toUpperCase()}
            </Avatar>
            <CaretDownOutlined className="ml-2 text-white" />
          </div>
        </ProfileDropdown>
      </div>
    </div>
  );
}
